import { Component, OnInit } from '@angular/core';
import { LookupDetail } from '../../models/lookup-detail.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ModalComponent } from '../../components/modal/modal.component';
import { LoginService } from 'src/app/user/services/login.service';
import { LookupService } from '../../services/lookup.service';
import { UINotificationService } from '../../services/ui-notification.service';
import { NotificationType } from '../../models/ui-notification.model';
import { EntityListRefresh } from '../../services/entity-list.refresh';

@Component({
  selector: 'app-basic-lookup-detail',
  templateUrl: './basic-lookup-detail.component.html',
  styleUrls: ['./basic-lookup-detail.component.css']
})
export class BasicLookupDetailComponent implements OnInit {
  form = new FormGroup({});
  item: LookupDetail;
  lookupType: string;
  langs = [
    { 'lang': 'cs', 'title': 'Česky' },
    { 'lang': 'en', 'title': 'Anglicky' },
    { 'lang': 'de', 'title': 'Německy' }
  ];

  constructor(
    private route: ActivatedRoute,
    private loginService: LoginService,
    private lookupService: LookupService,
    private uiNotificationService: UINotificationService,
    private entityListRefresh: EntityListRefresh
  ) { }

  ngOnInit() {
    this.item = this.route.snapshot.data.data;
    this.lookupType = this.route.snapshot.paramMap.get('type');

    const defaultLang = this.item.language.filter(item => item.twoLetterISOLanguageName === 'cs')[0];

    this.form.addControl('code', new FormControl(this.item.code, Validators.required));
    this.form.addControl('lang', new FormControl(this.langs[0], Validators.required));
    this.form.addControl('title', new FormControl(defaultLang.title, Validators.required));
    this.form.addControl('description', new FormControl(defaultLang.description));
  }

  close(modal: ModalComponent) {
    modal.closeModal(null);
  }

  onLangChange() {
    const lang = this.form.get('lang').value;
    const newLang = this.item.language.filter(item => item.twoLetterISOLanguageName === lang.lang)[0];

    this.form.patchValue({
      title: newLang.title,
      description: newLang.description
    });
  }

  onSubmit(modal: ModalComponent) {
    const lang = this.form.get('lang').value;
    let itemLang = this.item.language.filter(item => item.twoLetterISOLanguageName != lang.lang);
    itemLang.push({
      twoLetterISOLanguageName: lang.lang,
      title: this.form.get('title').value,
      description: this.form.get('description').value
    });

    if (this.form.valid && this.loginService.isSuperadmin()) {
      this.lookupService.update({
        id: this.item.id,
        code: this.form.get('code').value,
        language: itemLang
      }, this.lookupType).subscribe(() => {
        this.entityListRefresh.refresh('lookup');
        this.uiNotificationService.add({
          type: NotificationType.Info,
          message: 'Položka byla aktualizována'
        });
        modal.closeModal(null);
      });
    }
  }

}
